<template>
	<div id="recruit">
		<NavMenu :activeIndex="curIndex"></NavMenu>
		<div class="liuBai"></div>
		<div class="bannerImgCon"><el-image class="bannerImg" :src="baseImgUrl + recruitVo.banner" fit="cover"></el-image></div>
		<div class="main">
			<div class="tit">招聘信息</div>
			<div class="item" v-for="item in recruitVo.jobList" :key="item.id">
				<div class="name">{{item.tit}}</div>
				<div class="operate" @click="showJobInfo(item)">查看详细信息 ></div>
			</div>
			<div class="contact">
				投递邮箱：{{recruitVo.mail}}<br/>
				联系方式：{{recruitVo.tel.tel}}
			</div>
		</div>
		<Bottom></Bottom>
		<el-dialog :title="jobInfoShow.jobTit" :visible.sync="jobInfoVisible" top="5vh" center customClass="dialogWidth">
			<div v-html="this.$purify.sanitize(jobInfoShow.jobInfo)"></div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="jobInfoVisible = false">关闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import NavMenu from '../../../copms/NavMenu'
import Bottom from '../../../copms/Bottom'
export default {
	name: "Recruit",
	components: { NavMenu,Bottom },
	data() {
		return {
			curIndex: '6',
			baseImgUrl: process.env.VUE_APP_IMGURL,
			recruitVo: { banner: '', mail: '', tel: '', jobList: [] },
			jobInfoShow: { jobTit: '', jobInfo:'' },
			jobInfoVisible: false
		}
	},
	mounted() {
		this.$api.get('recruit/get').then(res => {
			this.recruitVo = res;
		});
	},
	methods: {
		showJobInfo(item){
			this.jobInfoShow.jobTit = item.tit;
			this.jobInfoShow.jobInfo = item.info;
			this.jobInfoVisible = true;
		}
	}
}
</script>

<style>
	html{ width: 100%; height: 100%; }
	body { margin: 0; padding: 0; width: 100%; height: 100%; }
	::-webkit-scrollbar { width: 5px; height: 6px; }
	::-webkit-scrollbar-track { background-color: #ffffff; border-radius: 2px; }
	::-webkit-scrollbar-thumb { background-color: #73869c; border-radius: 2px; border: 1px solid #6d6d6d; }
	* { scrollbar-color: light; scrollbar-width: thin; } /*火狐*/
</style>
<style scoped>
	.tit{ font-family: 'SiYuan-Normal', sans-serif; }
	.item, .contact{ font-family: 'SiYuan-ExtraLight', sans-serif; }
	@media (max-width: 726px){
		.liuBai{ height: 88px; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ width: 72%; margin: 0 auto; min-height: 280px; height: fit-content; }
		.tit{ width: fit-content; margin: 34px auto; text-align: center; font-size: 26px; animation: fadeInDown; animation-duration: 1.8s; }
		.item{ width: 100%; height: 100px; margin-bottom: 28px; border-radius: 8px; background-color: rgba(106, 141, 168, 0.4); animation: fadeInUp; animation-duration: 1.8s; }
		.name{ font-size: 16px; height: 70px; line-height: 75px; text-align: center; animation: fadeInLeft; animation-duration: 1s; }
		.operate{font-size: 12px; height: 30px; line-height: 30px; text-align: center; transition: all 0.2s linear; animation: fadeInRight; animation-duration: 1s; }
		.operate:hover{ cursor: pointer; color: #387ab6; letter-spacing: 1px; }
		.contact{ font-size: 14px; line-height: 20px; color: #496382; animation: fadeInUp; animation-duration: 1.8s; }
		::v-deep .dialogWidth{ width: 97%; }
	}
	@media (min-width: 726px) and (max-width: 999px){
		.liuBai{ height: 98px; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ width: 76%; margin: 0 auto; min-height: 360px; }
		.tit{ width: fit-content; margin: 42px auto; text-align: center; font-size: 30px; animation: fadeInDown; animation-duration: 1.8s; }
		.item{ width: 100%; height: 70px; line-height: 70px; margin-bottom: 24px; border-radius: 8px; background-color: rgba(106, 141, 168, 0.4); display: flex; justify-content: space-between; animation: fadeInUp; animation-duration: 1.8s; }
		.name{ margin-left: 50px; font-size: 17px; animation: fadeInLeft; animation-duration: 1s; }
		.operate{ margin-right: 50px; font-size: 15px; transition: all 0.2s linear; animation: fadeInRight; animation-duration: 1s; }
		.operate:hover{ cursor: pointer; color: #387ab6; letter-spacing: 1px; }
		.contact{ font-size: 14px; line-height: 20px; color: #496382; animation: fadeInUp; animation-duration: 1.8s; }
		::v-deep .dialogWidth{ width: 90%; }
	}
	@media (min-width: 999px) and (max-width: 1251px){
		.liuBai{ height: 98px; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ width: 78%; margin: 0 auto; min-height: 400px; }
		.tit{ width: fit-content; margin: 42px auto; text-align: center; font-size: 30px; animation: fadeInDown; animation-duration: 1.8s; }
		.item{ width: 100%; height: 80px; line-height: 80px; margin-bottom: 30px; border-radius: 8px; background-color: rgba(106, 141, 168, 0.4); display: flex; justify-content: space-between; animation: fadeInUp; animation-duration: 1.8s; }
		.name{ margin-left: 50px; font-size: 18px; animation: fadeInLeft; animation-duration: 1s; }
		.operate{ margin-right: 50px; font-size: 17px; transition: all 0.2s linear; animation: fadeInRight; animation-duration: 1s; }
		.operate:hover{ cursor: pointer; color: #387ab6; letter-spacing: 1px; }
		.contact{ font-size: 14px; line-height: 20px; color: #496382; animation: fadeInUp; animation-duration: 1.8s; }
		::v-deep .dialogWidth{ width: 88%; }
	}
	@media (min-width: 1252px) and (max-width: 1759px){
		.liuBai{ height: 98px; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ width: 80%; margin: 0 auto; min-height: 400px; }
		.tit{ width: fit-content; margin: 42px auto; text-align: center; font-size: 30px; animation: fadeInDown; animation-duration: 1.8s; }
		.item{ width: 100%; height: 80px; line-height: 80px; margin-bottom: 30px; border-radius: 8px; background-color: rgba(106, 141, 168, 0.4); display: flex; justify-content: space-between; animation: fadeInUp; animation-duration: 1.8s; }
		.name{ margin-left: 50px; font-size: 18px; animation: fadeInLeft; animation-duration: 1s; }
		.operate{ margin-right: 50px; font-size: 17px; transition: all 0.2s linear; animation: fadeInRight; animation-duration: 1s; }
		.operate:hover{ cursor: pointer; color: #387ab6; letter-spacing: 1px; }
		.contact{ font-size: 14px; line-height: 20px; color: #496382; animation: fadeInUp; animation-duration: 1.8s; }
		::v-deep .dialogWidth{ width: 80%; }
	}
	@media (min-width: 1760px) and (max-width: 2200px){
		.liuBai{ height: 98px; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ width: 62%; margin: 0 auto; min-height: 400px; }
		.tit{ width: fit-content; margin: 42px auto; text-align: center; font-size: 30px; animation: fadeInDown; animation-duration: 1.8s; }
		.item{ width: 100%; height: 80px; line-height: 80px; margin-bottom: 30px; border-radius: 8px; background-color: rgba(106, 141, 168, 0.4); display: flex; justify-content: space-between; animation: fadeInUp; animation-duration: 1.8s; }
		.name{ margin-left: 50px; font-size: 18px; animation: fadeInLeft; animation-duration: 1s; }
		.operate{ margin-right: 50px; font-size: 17px; transition: all 0.2s linear; animation: fadeInRight; animation-duration: 1s; }
		.operate:hover{ cursor: pointer; color: #387ab6; letter-spacing: 1px; }
		.contact{ font-size: 14px; line-height: 20px; color: #496382; animation: fadeInUp; animation-duration: 1.8s; }
		::v-deep .dialogWidth{ width: 66%; }
	}
	@media (min-width: 2201px){
		.liuBai{ height: 98px; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ width: 60%; margin: 0 auto; min-height: 460px; height: fit-content; }
		.tit{ width: fit-content; margin: 42px auto; text-align: center; font-size: 30px; animation: fadeInDown; animation-duration: 1.8s; }
		.item{ width: 100%; height: 100px; line-height: 100px; margin-bottom: 42px; border-radius: 8px; background-color: rgba(106, 141, 168, 0.4); display: flex; justify-content: space-between; animation: fadeInUp; animation-duration: 1.8s; }
		.name{ margin-left: 50px; font-size: 18px; animation: fadeInLeft; animation-duration: 1s; }
		.operate{ margin-right: 50px; font-size: 17px; transition: all 0.2s linear; animation: fadeInRight; animation-duration: 1s; }
		.operate:hover{ cursor: pointer; color: #387ab6; letter-spacing: 1px; }
		.contact{ font-size: 14px; line-height: 20px; color: #496382; animation: fadeInUp; animation-duration: 1.8s; }
		::v-deep .dialogWidth{ width: 60%; }
	}
</style>